module.exports = __webpack_public_path__ + "img/EmptyState.c8769b20.svg";